export const it = {
  configuration: {
    chooseSection: "Scegli una sezione",
    configuration: "Configurazione",
  },
  navigation: {
    configuration: "Configurazione",
  },
};
